import { FC } from 'react';
import { Link } from 'react-router-dom';
import { ImageResponseType } from '../../types/base';
import { generateImageUrl } from '../../helpers/generateImageUrl';
import clsx from 'clsx';
import styles from './Brand.module.scss';

export interface IBrandProps {
  href?: string;
  link?: string;
  className?: string;
  name: string;
  image: ImageResponseType;
  description?: string;
  classNameItem?: string;
  classNameFromPage?: string;
}

export const Brand: FC<IBrandProps> = ({
  description,
  image,
  name,
  className,
  href,
  link,
  classNameItem,
  classNameFromPage,
}) => {
  const content = (
    <>
      <div className={clsx(styles.imageWrapper, classNameFromPage)}>
        <img
          src={
            image?.s3Key
              ? generateImageUrl(image?.s3Key)
              : '/images/placeholderImage.png'
          }
          alt={name}
          className={clsx(styles.image, className)}
        />
      </div>
      {description && <p className={styles.description}>{description}</p>}
    </>
  );

  return href || link ? (
    <Link
      className={clsx(styles.Brand, classNameItem)}
      to={href ? href : link ? link : ''}
      target={link && '_blank'}
    >
      {content}
    </Link>
  ) : (
    <div className={styles.Brand}>{content}</div>
  );
};
